import script from "./FormCaption.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCaption.vue?vue&type=script&setup=true&lang=js"

import "./FormCaption.vue?vue&type=style&index=0&id=329a60fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329a60fc"]])

export default __exports__